import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
import FormAdvancedOptions from "./FormAdvancedOptions";
import INITIAL_FORMDATA from "./_initialFormData";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  var _a;
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval } = formData;
  const availableContent = [
    { label: "Archive Message View", value: "ARCHIVE_MESSAGE_VIEW" },
    { label: "Archive Search", value: "ARCHIVE_SEARCH" },
    { label: "Audit Events", value: "AUDIT_EVENTS" },
    { label: "DLP", value: "DLP" },
    { label: "Message Release", value: "MESSAGE_RELEASE" },
    { label: "Rejection", value: "REJECTION" },
    { label: "Search", value: "SEARCH" },
    { label: "TTP Attachment Protection", value: "TTP_ATTACHMENT_PROTECTION" },
    { label: "TTP Impersonation Protect", value: "TTP_IMPERSONATION_PROTECT" },
    { label: "TTP Url", value: "TTP_URL" },
    { label: "SIEM", value: "SIEM" }
  ];
  const contentTypes = ((_a = formData.contentTypes) == null ? void 0 : _a.value) || INITIAL_FORMDATA.availableContents.value;
  const [contentTypeVal, setContentTypeVal] = useState(false);
  const handleSubmit = () => {
    let error = false;
    if (contentTypes.length === 0) {
      setContentTypeVal(true);
      error = true;
    }
    if (pollingInterval.value < 1) {
      setFormError({
        full_message: "Please provide valid polling interval",
        nice_message: "Minimum allowable polling interval is 1 minute."
      });
      error = true;
    }
    if (!error) {
      setFormError(null);
      onChange({ target: { name: "contentTypes", value: contentTypes } });
      onSubmit();
    }
  };
  return /* @__PURE__ */ React.createElement(FormWrap, { onSubmit: handleSubmit, buttonContent: "Proceed", title: "", error: formError, description: "" }, /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, "Logs Types to Collect"), /* @__PURE__ */ React.createElement(
    Select,
    {
      multi: true,
      name: "contentTypes",
      id: "contentTypes",
      onChange: (selected) => {
        onChange({ target: { name: "contentTypes", value: selected } });
      },
      options: availableContent,
      value: contentTypes || ""
    }
  ), contentTypeVal && contentTypes.length === 0 && /* @__PURE__ */ React.createElement("label", { htmlFor: "contentTypes", style: { color: "red" } }, "Select at least one Log Type"), /* @__PURE__ */ React.createElement("span", { className: "help-block" }, "The activity log for the above content types will be fetched."), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pollingInterval",
      name: "pollingInterval",
      type: "number",
      value: pollingInterval.value || pollingInterval.defaultValue || "",
      min: "1",
      max: "60",
      step: "1",
      onChange,
      required: true,
      help: "Determines how often (in minutes) the input will check for new data from the Mimecast API. The smallest allowable interval is 1 minute.",
      label: "Polling Interval"
    }
  ), /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange }));
};
export default StepSubscribe;
